import { log, logError } from '../webUtils'
import { openChatPanel, reduceChatPanel } from '../actions/conversationActions'

const chatConversations = (state = [], action) => {
  var conv = undefined;
  switch (action.type) {
    case 'OPEN_CHAT_PANEL':
      conv = state.find(({ id }) => id == action.conversationId);
      if (conv) {
        return state.map(conversation => {
          if (conversation.id == action.conversationId) {
            return { ...conversation, isOpen: action.isOpen, isRead: true }
          }
          else
            return conversation;
        })
      }
      else
        return [...state, { id: 0, isOpen: action.isOpen, isRead: true }]
    case 'TOGGLE_CHAT_PANEL':
      conv = state.find(({ id }) => id == action.conversationId);
      if (!conv || !conv.isOpen) {
        action.asyncDispatch(openChatPanel(action.conversationId))
        return state;
      }
      else {
        action.asyncDispatch(reduceChatPanel(action.conversationId))
        return state;
      }
    case 'REDUCE_CHAT_PANEL':
      return state.map(conversation => {
        if (conversation.id == action.conversationId) {
          return { ...conversation, isOpen: false }
        }
        else
          return conversation;
      })
    case 'CLOSE_CHAT_PANEL':
      return state.filter(({ id }) => id != action.conversationId);
    case 'CLT_MISSION_CLOSE_SESSION':
    case 'CLOSE_ALL_CHAT_PANELS':
      return [];
    case 'PUSH_CHAT_MESSAGE':
      conv = state.find(({ id }) => id == action.conversationId)
      if (!conv) {
        // Closed conversation
        return state;
      }
      if (!conv.isOpen) {
        return state.map(conv => {
          if (conv.id == action.conversationId)
            return { ...conv, isRead: false }
          else
            return state;
        })
      }
      else
        return state;
    case 'CLT_START_MISSION':
      return [...state, { id: 0, isRead: true }]
    default:
      return state
  }
}

export default chatConversations
